import React, { useEffect, useCallback, useState } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { Card } from "primereact/card";
import { useTranslation } from "react-i18next";
import TelecelCashLogo from "../../assets/images/Telecel-Cash-Logo.jpg";
import ATMoneyLogo from "../../assets/images/AT-LOGO.png";
import MTN_MomoLogo from "../../assets/images/momo.jpg";
import Mastercard from "../../assets/images/mastercard.png";
import Visacard from "../../assets/images/visacard.png";
import { Link } from 'react-router-dom';
import DefMembershipActions from "../../Redux/actions/defMembership-actions";
import PaySwitchActions from "../../Redux/transition/payswitch/payswitch.reducer";
import DocumentActions from '../../Redux/transition/document-upload/document-upload.reducer';
import BusinessActions from "../../Redux/actions/business-actions";
import Loading from "../../Components/Loading";
import { getPaymentProviderUiStatus } from "../../utils/paymentProviderStatus";
import "../../Styles/pages/settings.scss";

function PaymentProviders() {
    const { t } = useTranslation("common");

    const defMembership = useSelector((state) => state.defMembership.defMembership);
    const verifStatus = useSelector((state) => state.documents.verifStatus);
    const paymentCredentials = useSelector((state) => state.payswitch.credentials);
    const business = useSelector((state) => state.businesses.business);
    const fetchingVerifStatus = useSelector((state) => state.documents.fetchingVerifStatus);
    const fetchingPaymentCredentials = useSelector((state) => state.payswitch.fetchingCredentials);
    const fetchingBusiness = useSelector((state) => state.businesses.fetchingOne);

    const dispatch = useDispatch()
    const getBusiness = useCallback((businessId) => { dispatch(BusinessActions.businessRequest(businessId)) }, [dispatch])
    const getMembership = useCallback(() => { dispatch(DefMembershipActions.defMembershipRequest()) }, [dispatch])
    const getVerificationRecord = useCallback((businessId) => { dispatch(DocumentActions.businessVerificationStatusRequest(businessId)) }, [dispatch]);
    const getCredentials = useCallback((businessId, provider) => { dispatch(PaySwitchActions.paySwitchCredentialRequest(businessId, provider)) }, [dispatch]);

    const [hasRequested, setHasRequested] = useState(false);
    const [requestedProvider, setRequestedProvider] = useState(null);
    const [initialLoadDone, setInitialLoadDone] = useState(false);
    const businessId = defMembership?.business?.id;

    useEffect(() => {
        if (!businessId) {
            if (!defMembership) {
                getMembership();
            }
            return;
        }
        getBusiness(businessId);
        getVerificationRecord(businessId);
        setHasRequested(true);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [businessId]);

    useEffect(() => {
        if (!hasRequested || !businessId || !business?.pmtProvider) {
            return;
        }
        getCredentials(businessId, business.pmtProvider);
        setRequestedProvider(business.pmtProvider);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hasRequested, businessId, business?.pmtProvider]);

    useEffect(() => {
        if (!hasRequested || initialLoadDone) {
            return;
        }
        if (fetchingBusiness === true || fetchingVerifStatus) {
            return;
        }
        if (business?.pmtProvider && (requestedProvider !== business.pmtProvider || fetchingPaymentCredentials)) {
            return;
        }
        setInitialLoadDone(true);
    }, [hasRequested, initialLoadDone, fetchingBusiness, fetchingVerifStatus, fetchingPaymentCredentials, business?.pmtProvider, requestedProvider]);

    const pmtProviderArray = [
        {
            id: 1,
            reference: 'APPSNMOBILE',
            name: t("api_settings.appsNmobile_ltd_txt"),
            description: t("api_settings.OrchardPay_txt"),
            navigation: "/payment_providers/appsNmobile"
        },
        {
            id: 2,
            reference: 'PAYSWITCH',
            name: t("login.payswitch_txt"),
            description: t("api_settings.The_teller_txt"),
            preferredTag: t("api_settings.preferred"),
            navigation: "/payment_providers/paySwitch"
        }
        ,
        {
            id: 3,
            reference: 'JUNIPAY',
            name: t("api_settings.junipay_txt"),
            description: t("api_settings.Junipay"),
            preferredTag: t("api_settings.preferred"),
            navigation: "/payment_providers/junipay"
        },
        {
            id: 4,
            reference: 'ALPAY',
            name: t("api_settings.alpay_ltd_txt"),
            description: t("api_settings.alPay_txt"),
            preferredTag: t("api_settings.preferred"),
            navigation: "/payment_providers/alpay"
        },
        {
            id: 5,
            reference: 'PAYSTACK',
            name: t("api_settings.paystack_profile_name"),
            description: t("api_settings.paystack_txt"),
            preferredTag: t("api_settings.preferred"),
            navigation: "/payment_providers/paystack"
        }
    ];

    if (!initialLoadDone || !business) {
        return <Loading />;
    }

    return (
        <div>
            <Card className="provider_list">
                <div className="provider_list_header_div">
                    <p className="provider_list_header">{t("api_settings.provider_list_header")}</p>
                    <p className="provider_list_txt">{t("api_settings.provider_list_txt")}</p>
                </div>

                <div className="main_provider_items">
                    {pmtProviderArray.map((item) => {
                        const providerStatus = getPaymentProviderUiStatus(item.reference, {
                            business,
                            paymentCredentials,
                            verifStatus,
                            requireVerified: false,
                        });

                        return (
                        <Link
                            to={`${item.navigation}`}
                            key={item.id}>
                            <div className="grid provider_list_row align-items-center">
                                <div className="col-12 md:col-4" id="left_main_provider_items">
                                    <div className="left_div_provider_items">
                                        <div>
                                            <p className="appsNmobile_ltd_txt">{item.name}</p>
                                            <p className="orchardPay_txt_list">{item.description}</p>
                                        </div>
                                    </div>
                                </div>

                                {['PAYSWITCH', 'PAYSTACK'].includes(item.reference) ?
                                    <div className="col-12 sm:col-6 md:col-4 payment_methods_logos">
                                        <img src={MTN_MomoLogo} alt="MTNMomo" />
                                        <img src={ATMoneyLogo} alt="ATMoney" />
                                        <img src={TelecelCashLogo} alt="TCashLogo" />
                                        <img src={Mastercard} alt="MasterCard" />
                                        <img src={Visacard} alt="VisaCard" />
                                    </div>
                                    :
                                    <div className="col-12 sm:col-6 md:col-4 payment_methods_logos">
                                        <img src={MTN_MomoLogo} alt="MTNMomo" />
                                        <img src={ATMoneyLogo} alt="ATMoney" />
                                        <img src={TelecelCashLogo} alt="TCashLogo" />
                                    </div>}

                                <div className="col-12 sm:col-6 md:col-4 right_side_labels">
                                    {providerStatus === "NOT_ACTIVATED" && <span id="not_activated_label">{t("api_settings.not_activated_label")}</span>}

                                    {providerStatus === "ACTIVE" && <span className="active_label">{t("api_settings.active_label")}</span>}

                                    {providerStatus === "IN_PROGRESS" && <span className="in_progress_label">{t("api_settings.in_progress_label")} </span>}
                                    <i className='pi pi-chevron-right payments_chevron_right'></i>
                                </div>
                            </div>
                            {[1, 2, 3, 4].includes(item.id) && <hr className="hr_providers" />}
                        </Link>
                    )})}
                </div>
            </Card >
        </div >
    )
}

export default PaymentProviders;
